import { useEffect, useRef, useState } from 'react';

const DEFAULT_DURATION = 660;

export const useAnimatedNumber = (target: number | null, duration = DEFAULT_DURATION) => {
  const [display, setDisplay] = useState(target);
  const prev = useRef(target);

  useEffect(() => {
    if (target === null) {
      return;
    }

    const from = prev.current;
    prev.current = target;
    if (from === target) {
      return;
    }

    const start = performance.now();
    let frameId: number;

    const tick = (now: number) => {
      if (from === null) {
        return;
      }

      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - progress) * (1 - progress);
      setDisplay(from + (target - from) * eased);
      if (progress < 1) {
        frameId = requestAnimationFrame(tick);
      }
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [target, duration]);

  return display;
};
